// AUTO-GENERATED — do not edit by hand.
// Run `bun scripts/snapshot_marketing_meta.ts` to refresh.
// Source: REGISTRY in @memkernel/integrations (top100 rank order).

import type { Integration } from "./integrations";

export const INTEGRATIONS_META: readonly Integration[] = [
  {
    "slug": "github",
    "name": "GitHub",
    "category": "code",
    "summary": "Browse repositories, manage issues and pull requests, and inspect users and organizations on GitHub."
  },
  {
    "slug": "gmail",
    "name": "Gmail",
    "category": "email",
    "summary": "Read, send, and search mail in the user's Gmail mailbox."
  },
  {
    "slug": "slack",
    "name": "Slack",
    "category": "messaging",
    "summary": "Post messages, search history, and manage channels and users in a Slack workspace."
  },
  {
    "slug": "notion",
    "name": "Notion",
    "category": "docs-knowledge",
    "summary": "Read and write Notion pages, databases, and blocks from an agent or automation."
  },
  {
    "slug": "googlesheets",
    "name": "Google Sheets",
    "category": "data",
    "summary": "Read, write, and append rows to Google Sheets spreadsheets."
  },
  {
    "slug": "shopify",
    "name": "Shopify",
    "category": "ecommerce",
    "summary": "Manage products, orders, customers, and inventory in a Shopify store via the Admin GraphQL API."
  },
  {
    "slug": "googledrive",
    "name": "Google Drive",
    "category": "files",
    "summary": "List, read, and create files in the user's Google Drive."
  },
  {
    "slug": "supabase",
    "name": "Supabase",
    "category": "data",
    "summary": "Manage Supabase projects, databases, and functions via the Supabase Management API."
  },
  {
    "slug": "hubspot",
    "name": "HubSpot",
    "category": "crm",
    "summary": "Manage contacts, companies, deals, and engagements in HubSpot."
  },
  {
    "slug": "linear",
    "name": "Linear",
    "category": "issue-tracking",
    "summary": "Manage Linear issues, projects, and teams via Linear's GraphQL API."
  },
  {
    "slug": "jira",
    "name": "Jira",
    "category": "issue-tracking",
    "summary": "Search, create, and comment on Jira Cloud issues across the user's Atlassian sites."
  },
  {
    "slug": "asana",
    "name": "Asana",
    "category": "issue-tracking",
    "summary": "Read and create Asana tasks, browse projects, and discover the user's workspaces."
  },
  {
    "slug": "trello",
    "name": "Trello",
    "category": "issue-tracking",
    "summary": "Browse boards, create cards, and post comments on the user's Trello workspace."
  },
  {
    "slug": "clickup",
    "name": "ClickUp",
    "category": "issue-tracking",
    "summary": "Manage ClickUp Workspaces, Spaces, and tasks — list, create, and comment on work items."
  },
  {
    "slug": "monday",
    "name": "Monday",
    "category": "issue-tracking",
    "summary": "Query monday.com boards, items, and updates via the GraphQL Platform API."
  },
  {
    "slug": "salesforce",
    "name": "Salesforce",
    "category": "crm",
    "summary": "Query and write Salesforce records via SOQL and the REST sObjects endpoints."
  },
  {
    "slug": "stripe",
    "name": "Stripe",
    "category": "billing",
    "summary": "Read and write Stripe customers, charges, refunds, and one-off payment links."
  },
  {
    "slug": "zoom",
    "name": "Zoom",
    "category": "video",
    "summary": "Schedule, list, and cancel Zoom meetings for the authenticated user."
  },
  {
    "slug": "calendly",
    "name": "Calendly",
    "category": "scheduling",
    "summary": "Read the user's Calendly event types, list and cancel scheduled events, and look up invitees."
  },
  {
    "slug": "microsoft_teams",
    "name": "Microsoft Teams",
    "category": "messaging",
    "summary": "Browse Microsoft Teams teams, channels, and chats — and post messages on behalf of the user via Microsoft Graph."
  },
  {
    "slug": "outlook",
    "name": "Outlook",
    "category": "email",
    "summary": "Read, search, send, and manage mail in the user's Outlook mailbox via Microsoft Graph."
  },
  {
    "slug": "googlecalendar",
    "name": "Google Calendar",
    "category": "calendar",
    "summary": "Read and manage events on the user's Google Calendar — list calendars, fetch events, and create or delete entries."
  },
  {
    "slug": "dropbox",
    "name": "Dropbox",
    "category": "files",
    "summary": "Browse, search, create, and delete files and folders in the user's Dropbox via the v2 RPC API."
  },
  {
    "slug": "airtable",
    "name": "Airtable",
    "category": "data",
    "summary": "Inspect Airtable bases and tables, list and filter records, and create or delete records in the user's bases."
  },
  {
    "slug": "discord",
    "name": "Discord",
    "category": "messaging",
    "summary": "Drive a Discord bot — list guilds and channels, post messages, and read channel history."
  },
  {
    "slug": "telegram",
    "name": "Telegram",
    "category": "messaging",
    "summary": "Drive a Telegram bot — send messages, poll for updates, inspect chats, and delete messages."
  },
  {
    "slug": "whatsapp",
    "name": "WhatsApp",
    "category": "messaging",
    "summary": "Send WhatsApp messages and templates from a business phone number via Meta's Cloud API."
  },
  {
    "slug": "twitter",
    "name": "X (Twitter)",
    "category": "social",
    "summary": "Search recent tweets, fetch tweet and user metadata, and post or delete tweets via the X API v2."
  },
  {
    "slug": "linkedin",
    "name": "LinkedIn",
    "category": "social",
    "summary": "Read the authenticated member's LinkedIn profile, publish text posts, and list the organizations they can administer."
  },
  {
    "slug": "youtube",
    "name": "YouTube",
    "category": "video",
    "summary": "Search YouTube videos, fetch metadata and statistics, list a channel's uploads and playlists, and inspect the signed-in user's channel."
  },
  {
    "slug": "facebook",
    "name": "Facebook",
    "category": "social",
    "summary": "Read profile data, manage Pages, and publish posts via the Meta Graph API."
  },
  {
    "slug": "instagram",
    "name": "Instagram",
    "category": "social",
    "summary": "Read Instagram Business accounts, list and publish media, and fetch per-post insights via the Meta Graph API."
  },
  {
    "slug": "tiktok",
    "name": "TikTok",
    "category": "social",
    "summary": "Read TikTok user profiles, list and query videos, and publish new content via the TikTok Open API."
  },
  {
    "slug": "reddit",
    "name": "Reddit",
    "category": "social",
    "summary": "Read subreddit feeds, fetch submissions, search Reddit, and post submissions or comments via the Reddit API."
  },
  {
    "slug": "mailchimp",
    "name": "Mailchimp",
    "category": "email",
    "summary": "Manage audiences, members, and campaigns in Mailchimp — list, upsert, and delete subscribers via the Marketing API."
  },
  {
    "slug": "sendgrid",
    "name": "SendGrid",
    "category": "email",
    "summary": "Send transactional email and manage marketing contacts, templates, and suppressions on Twilio SendGrid."
  },
  {
    "slug": "klaviyo",
    "name": "Klaviyo",
    "category": "email",
    "summary": "Read and create Klaviyo profiles, fire metric events, manage lists, and bulk-subscribe contacts."
  },
  {
    "slug": "intercom",
    "name": "Intercom",
    "category": "support",
    "summary": "Manage Intercom contacts and conversations — list, search, create, reply, and close from a single integration."
  },
  {
    "slug": "zendesk",
    "name": "Zendesk",
    "category": "support",
    "summary": "Read and write Zendesk Support tickets — list, search, create, update, and manage users."
  },
  {
    "slug": "freshdesk",
    "name": "Freshdesk",
    "category": "support",
    "summary": "Read and write Freshdesk tickets — list, create, update, reply, add notes, and manage contacts."
  },
  {
    "slug": "figma",
    "name": "Figma",
    "category": "design",
    "summary": "Inspect Figma files — read the document tree, render images, browse team projects, and manage comments."
  },
  {
    "slug": "miro",
    "name": "Miro",
    "category": "design",
    "summary": "Read and write Miro boards — list boards, manage items, and post sticky notes through the REST API."
  },
  {
    "slug": "canva",
    "name": "Canva",
    "category": "design",
    "summary": "Manage Canva designs, folders, and exports through the Connect API."
  },
  {
    "slug": "openai",
    "name": "OpenAI",
    "category": "ai-llm",
    "summary": "Call OpenAI models — chat completions, embeddings, image generation, and file management through the official REST API."
  },
  {
    "slug": "gemini",
    "name": "Gemini",
    "category": "ai-llm",
    "summary": "Call Google's Gemini models — generate content, count tokens, and compute embeddings through the Generative Language API."
  },
  {
    "slug": "perplexityai",
    "name": "Perplexity AI",
    "category": "ai-llm",
    "summary": "Ask Perplexity's Sonar models — web-search-augmented chat completions that return cited answers."
  },
  {
    "slug": "anthropic_administrator",
    "name": "Anthropic Administrator",
    "category": "ai-llm",
    "summary": "Administer an Anthropic organization — manage workspaces, members, invites, and API keys via the Admin API."
  },
  {
    "slug": "elevenlabs",
    "name": "ElevenLabs",
    "category": "ai-llm",
    "summary": "Synthesize speech, browse voices, and manage the TTS history through the ElevenLabs API."
  },
  {
    "slug": "pinecone",
    "name": "Pinecone",
    "category": "data",
    "summary": "Operate Pinecone vector indexes — upsert, query, fetch, and manage vectors plus index metadata."
  },
  {
    "slug": "replicate",
    "name": "Replicate",
    "category": "ai-llm",
    "summary": "Run open-source ML models on Replicate — predictions, deployments, and the model catalog."
  },
  {
    "slug": "firecrawl",
    "name": "Firecrawl",
    "category": "browser",
    "summary": "Turn websites into clean, LLM-ready data — scrape a single page, crawl a whole site, or map every URL beneath a root."
  },
  {
    "slug": "tavily",
    "name": "Tavily",
    "category": "search",
    "summary": "AI-native search, extract, crawl, and map APIs purpose-built for LLM agents that need fresh, well-ranked web data."
  },
  {
    "slug": "exa",
    "name": "Exa",
    "category": "search",
    "summary": "Neural web search built for AI agents — search, find similar pages, fetch cleaned contents, and get cited answers."
  },
  {
    "slug": "serpapi",
    "name": "SerpApi",
    "category": "search",
    "summary": "Scrape Google, Bing, and other search engines through SerpApi's managed proxy + parser stack. Real-time SERPs as structured JSON."
  },
  {
    "slug": "apify",
    "name": "Apify",
    "category": "browser",
    "summary": "Run any Actor from the Apify store — scrape sites, automate browsers, extract data — and stream results from Apify datasets."
  },
  {
    "slug": "browserbase_tool",
    "name": "Browserbase",
    "category": "browser",
    "summary": "Managed headless-browser infrastructure — spin up sessions, drive them with Playwright / Puppeteer / Selenium, and replay recordings."
  },
  {
    "slug": "brightdata",
    "name": "Bright Data",
    "category": "browser",
    "summary": "Trigger Bright Data Web Scraper collectors, download their datasets, and run SERP queries through Bright Data's managed proxy network."
  },
  {
    "slug": "amplitude",
    "name": "Amplitude",
    "category": "analytics",
    "summary": "Send events and identify users to Amplitude Analytics via the HTTP V2 ingestion API."
  },
  {
    "slug": "mixpanel",
    "name": "Mixpanel",
    "category": "analytics",
    "summary": "Track events, identify users and groups, import historical data, and run JQL queries against Mixpanel projects."
  },
  {
    "slug": "segment",
    "name": "Segment",
    "category": "analytics",
    "summary": "Send identify, track, page, group, alias and batch calls into a Segment source via the HTTP Tracking API."
  },
  {
    "slug": "posthog",
    "name": "PostHog",
    "category": "analytics",
    "summary": "Capture events, query HogQL, and inspect feature flags / insights on a PostHog project."
  },
  {
    "slug": "google_analytics",
    "name": "Google Analytics",
    "category": "analytics",
    "summary": "Query GA4 properties — run custom reports, real-time reports, and discover the dimensions and metrics each property exposes."
  },
  {
    "slug": "datadog",
    "name": "Datadog",
    "category": "monitoring",
    "summary": "Query metrics, search logs and events, and manage monitors / incidents on a Datadog org."
  },
  {
    "slug": "sentry",
    "name": "Sentry",
    "category": "monitoring",
    "summary": "Read and triage Sentry issues, list releases, and update issue status on a Sentry organization."
  },
  {
    "slug": "pagerduty",
    "name": "PagerDuty",
    "category": "monitoring",
    "summary": "Trigger, acknowledge, and resolve PagerDuty incidents, and list services / users / on-call schedules."
  },
  {
    "slug": "grafana",
    "name": "Grafana",
    "category": "monitoring",
    "summary": "Search dashboards, run datasource queries, and inspect alert rules / annotations on a Grafana instance."
  },
  {
    "slug": "bugsnag",
    "name": "Bugsnag",
    "category": "monitoring",
    "summary": "Read and triage Bugsnag errors, list events, and update error status across projects in an organization."
  },
  {
    "slug": "snowflake",
    "name": "Snowflake",
    "category": "data",
    "summary": "Submit SQL statements and inspect databases / warehouses via the Snowflake SQL API."
  },
  {
    "slug": "databricks",
    "name": "Databricks",
    "category": "data",
    "summary": "Manage Databricks clusters and jobs and execute SQL on Databricks SQL warehouses."
  },
  {
    "slug": "googlebigquery",
    "name": "Google BigQuery",
    "category": "data",
    "summary": "Run SQL queries, inspect datasets / tables, and manage jobs on Google BigQuery."
  },
  {
    "slug": "metabase",
    "name": "Metabase",
    "category": "analytics",
    "summary": "Query cards, dashboards, and run ad-hoc MBQL or SQL against a Metabase instance using a tenant-issued API key."
  },
  {
    "slug": "pipedrive",
    "name": "Pipedrive",
    "category": "crm",
    "summary": "Manage deals, persons, organizations, and activities in a Pipedrive CRM workspace via the v1 REST API."
  },
  {
    "slug": "zoho",
    "name": "Zoho CRM",
    "category": "crm",
    "summary": "Read and write CRM records (Leads, Contacts, Accounts, Deals, Tasks) on a Zoho CRM org via the v8 REST API."
  },
  {
    "slug": "attio",
    "name": "Attio",
    "category": "crm",
    "summary": "Query, create, and update records on Attio objects — people, companies, custom objects — and add notes to records."
  },
  {
    "slug": "close",
    "name": "Close",
    "category": "crm",
    "summary": "Manage leads, contacts, opportunities, tasks, and email activities in a Close CRM workspace via the v1 REST API."
  },
  {
    "slug": "apollo",
    "name": "Apollo",
    "category": "crm",
    "summary": "Search and enrich people and organizations on the Apollo.io database, manage contacts, and create outbound emailer sequences."
  },
  {
    "slug": "paypal",
    "name": "PayPal",
    "category": "billing",
    "summary": "Create checkout orders, capture or authorise payments, refund captures, and read transaction history via the PayPal REST API."
  },
  {
    "slug": "square",
    "name": "Square",
    "category": "billing",
    "summary": "Take payments, manage catalog items, search orders, and read or write customer profiles on a Square seller account."
  },
  {
    "slug": "razorpay",
    "name": "Razorpay",
    "category": "billing",
    "summary": "Create orders, capture and refund payments, and manage customers on a Razorpay merchant account."
  },
  {
    "slug": "quickbooks",
    "name": "QuickBooks",
    "category": "billing",
    "summary": "Query, create, and send accounting entities (customers, invoices, accounts) on a QuickBooks Online company."
  },
  {
    "slug": "xero",
    "name": "Xero",
    "category": "billing",
    "summary": "Read and create accounting records in a Xero organisation — invoices, contacts, accounts, and organisation metadata."
  },
  {
    "slug": "docusign",
    "name": "DocuSign",
    "category": "files",
    "summary": "Send, void, and inspect DocuSign envelopes and templates on the eSignature REST API v2.1."
  },
  {
    "slug": "dropbox_sign",
    "name": "Dropbox Sign",
    "category": "files",
    "summary": "Send, cancel, and inspect Dropbox Sign (formerly HelloSign) signature requests and templates over the v3 REST API."
  },
  {
    "slug": "typeform",
    "name": "Typeform",
    "category": "forms",
    "summary": "Manage Typeform forms, fetch responses, and inspect webhooks via the Typeform Create and Responses APIs."
  },
  {
    "slug": "jotform",
    "name": "Jotform",
    "category": "forms",
    "summary": "Manage Jotform forms and submissions — list questions, fetch responses, and prune submissions via the public REST API."
  },
  {
    "slug": "eventbrite",
    "name": "Eventbrite",
    "category": "scheduling",
    "summary": "Manage Eventbrite events, attendees, and orders — list, publish, and unpublish events under any organization the token can reach."
  },
  {
    "slug": "googleads",
    "name": "Google Ads",
    "category": "analytics",
    "summary": "Query and mutate Google Ads campaigns — run GAQL searches and mutate campaigns / ad groups / keywords across every customer the OAuth user can reach."
  },
  {
    "slug": "metaads",
    "name": "Meta Ads",
    "category": "analytics",
    "summary": "Manage Meta (Facebook + Instagram) ad accounts, campaigns, ad sets, ads, and pull insights via the Marketing API."
  },
  {
    "slug": "linkedin_ads",
    "name": "LinkedIn Ads",
    "category": "analytics",
    "summary": "Inspect LinkedIn ad accounts, campaigns, campaign groups, creatives, and run ad analytics queries via the LinkedIn Marketing API."
  },
  {
    "slug": "reddit_ads",
    "name": "Reddit Ads",
    "category": "analytics",
    "summary": "Manage Reddit ad accounts, campaigns, ad groups, and ads — and run performance reports via the Reddit Ads v3 API."
  },
  {
    "slug": "webflow",
    "name": "Webflow",
    "category": "no-code",
    "summary": "Manage Webflow sites, CMS collections, items, and assets — list, create, update, and publish content via the Data API v2."
  },
  {
    "slug": "resend",
    "name": "Resend",
    "category": "email",
    "summary": "Send transactional emails, manage audiences and contacts, and operate sending domains via Resend's REST API."
  },
  {
    "slug": "contentful",
    "name": "Contentful",
    "category": "docs-knowledge",
    "summary": "Manage Contentful spaces, environments, content types, entries, and assets via the Content Management API."
  },
  {
    "slug": "sanity",
    "name": "Sanity",
    "category": "docs-knowledge",
    "summary": "Query and mutate Sanity Content Lake documents with GROQ, and manage projects and datasets via Sanity's HTTP APIs."
  },
  {
    "slug": "prismic",
    "name": "Prismic",
    "category": "docs-knowledge",
    "summary": "Query published documents in a Prismic repository — predicate search, lookup by id/uid, and full-text search via the REST API v2."
  },
  {
    "slug": "spotify",
    "name": "Spotify",
    "category": "social",
    "summary": "Search the Spotify catalog, manage playlists and saved tracks, and control the user's playback via the Web API."
  },
  {
    "slug": "google_chat",
    "name": "Google Chat",
    "category": "messaging",
    "summary": "Send messages, manage spaces, and operate memberships across a Google Workspace via the Google Chat REST API."
  },
  {
    "slug": "neon",
    "name": "Neon",
    "category": "data",
    "summary": "Manage serverless Postgres projects, branches, databases, roles, and compute endpoints on Neon via its control-plane REST API."
  },
  {
    "slug": "algolia",
    "name": "Algolia",
    "category": "search",
    "summary": "Search Algolia indices, batch upsert and delete records, and manage index settings via the Search & Indexing REST APIs."
  },
  {
    "slug": "cloudflare",
    "name": "Cloudflare",
    "category": "monitoring",
    "summary": "Manage Cloudflare zones, DNS records, page rules, firewall rules, cache purges, and analytics via the API v4."
  }
];
